import script from "./AgendorMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgendorMenu.vue?vue&type=script&setup=true&lang=ts"

import "./AgendorMenu.vue?vue&type=style&index=0&id=051bd136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051bd136"]])

export default __exports__